document.getElementById('create_customer').addEventListener('submit', function(event) {
    var firstNameInput = document.getElementById('RegisterForm-FirstName');
    var firstNameError = document.getElementById('RegisterForm-first_name-error');
    
    var emailInput = document.getElementById('RegisterForm-email');
    var emailError = document.getElementById('RegisterForm-email-error');
    
    var passwordInput = document.getElementById('RegisterForm-password');
    var passwordError = document.getElementById('RegisterForm-password-error');

    var phoneInput = document.getElementById('RegisterForm-Phone');
    var phoneErrorText = document.querySelector('#RegisterForm-Phone-error span');
    var phoneError = document.getElementById('RegisterForm-Phone-error');
    
    var formIsValid = true;  // Flag to check if the form is valid
    
    // Check if the first name input is blank
    if (!firstNameInput.value.trim()) {
        firstNameError.style.display = 'flex';  // Show the error message with flex display
        formIsValid = false;  // Mark form as invalid
    } else {
        firstNameError.style.display = 'none';  // Hide the error message if the input is not blank
    }
    
    // Check if the email input is blank
    if (!emailInput.value.trim()) {
        emailError.style.display = 'flex';  // Show the error message with flex display
        formIsValid = false;  // Mark form as invalid
    } else {
        emailError.style.display = 'none';  // Hide the error message if the input is not blank
    }

    // Check if the password input is blank
    if (!passwordInput.value.trim()) {
        passwordError.style.display = 'flex';  // Show the error message with flex display
        formIsValid = false;  // Mark form as invalid
    } else {
        passwordError.style.display = 'none';  // Hide the error message if the input is not blank
    }

    if (!phoneInput.value.trim()) {
        phoneErrorText.textContent = "Phone number cannot be blank!";
        phoneError.style.display = 'flex';
        formIsValid = false;
    } else if (!/^\d{10}$/.test(phoneInput.value.trim())) {
        phoneErrorText.textContent = "Phone number must be 10 digits.";
        phoneError.style.display = 'flex';
        formIsValid = false;
    } else {
        phoneError.style.display = 'none';
    }

    
    // If the form is invalid, prevent submission
    if (!formIsValid) {
        event.preventDefault();
    }


      const signUpForm = document.querySelector('#create_customer');
      const input_fn = signUpForm.querySelector('[name="customer[first_name]"]').value || '';
      const input_ln = signUpForm.querySelector('[name="customer[last_name]"]').value || '';
      const input_email = signUpForm.querySelector('[name="customer[email]"]').value || '';
      const input_phone = signUpForm.querySelector('[name="customer[phone]"]').value || '';
      const isConsentChecked = signUpForm.querySelector('#myCheckbox_reg').checked;
      
      // API headers and data
      const header_value = {
          isoLanguage: "EN",
          isoCountry: "IN",
          brandCode: "BH8702",
          campaignId: "PN002392",
          campaignDescription: "Always On",
          origin: "https://lovebeautyandplanet.in/",
          formType: "signUp",
          entity: "PRM2.6"
      };
      
      const x_api_key = "665fb793-eb8d-42ed-85e7-31981ee4ac1a";
      
      const consumerIdentity = {
          firstName: input_fn,
          lastName: input_ln
      };
      
      const contactDetail = {
          email: input_email,
          mobileNumber: `+91${input_phone}`
      };
      
      const optInStatus = {
          legalAgeConsent: isConsentChecked,
          unileverEmailConsent: isConsentChecked,
          unileverSMSConsent: isConsentChecked
      };
      
      // Prepare the request body
      const data_value = JSON.stringify({
          profile: {
              header: header_value,
              consumerIdentity,
              contactDetail,
              optInStatus
          }
      });


      if (isConsentChecked == true) {
      // Send the form data to your API
        fetch("https://forms-sg.unileversolutions.com/v3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": x_api_key
            },
            body: data_value
        })
        .then(response => {
            if (response.ok) {
                // If the API call is successful, submit the form to Shopify
                contactForm.submit();
            } else {
                console.error('API request failed');
                // Optionally, display an error message to the user
                // alert('Failed to submit the form. Please try again.');
              contactForm.submit();
            }
        })
        .catch(error => {
            console.error('Error:', error);
            // Optionally, display an error message to the user
            // alert('An error occurred. Please try again.');
          contactForm.submit();
        });
      }
      else {
        contactForm.submit();
      }
  
});
